import {get, post} from './axios2'
import {addHeaders} from './authHeader'

const autoRoutingApiUri = process.env.VUE_APP_AUTO_ROUTER_API_URI + '/'

export async function autoRoutingGet(url) {
  return await request(url, null, 'get')
}

export async function autoRoutingPost(url, data) {
  return await request(url, data, 'post')
}

export async function autoRoutingApiUp() {
  return await request('actuator/health', null, 'get')
}

async function request(url, data, method) {
  switch (method) {
    case 'get':
      return await get(autoRoutingApiUri + url, await addHeaders())
    case 'post':
      return await post(autoRoutingApiUri + url, await addHeaders(), data)
  }
}
